import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "positionWrap"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "el-form-w2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_slider_input = _resolveComponent("slider-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input_number = _resolveComponent("el-input-number");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_component_slider_input, {
    title: "宽度",
    max: $data.max,
    size: $data.width,
    onInput: _cache[0] || (_cache[0] = $event => $options.inputChange($event, 'width'))
  }, null, 8, ["max", "size"]), [[_vShow, $props.showWidth]]), _createVNode(_component_el_form_item, null, {
    label: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("span", null, "定位", -1)])),
    default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pArr, (item, index) => {
      return _openBlock(), _createElementBlock("li", {
        key: index,
        class: _normalizeClass({
          'active': $data.pIndex === index
        }),
        onClick: $event => $options.changeHandle(item, index)
      }, [_createElementVNode("i", {
        class: _normalizeClass(`icon ${item.icon}`)
      }, null, 2)], 10, _hoisted_2);
    }), 128))])]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.ptypeArr, (item, index) => {
    return _withDirectives((_openBlock(), _createBlock(_component_el_form_item, {
      key: index
    }, {
      label: _withCtx(() => [_createElementVNode("span", null, "距" + _toDisplayString(item.name), 1)]),
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        modelValue: $data.pos[item.type],
        "onUpdate:modelValue": $event => $data.pos[item.type] = $event,
        "controls-position": "right",
        max: $data.max,
        onInput: $event => $options.inputNumberChange($event, item.type)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onInput"]), _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "unit"
      }, "px", -1))]),
      _: 2
    }, 1024)), [[_vShow, $data.ptype.includes(item.type)]]);
  }), 128))])]);
}